import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const StyledContainer = styled(FlexColumn, {
  width: '100%',
})

export const StyledResult = styled('div', ({ $theme }) => ({
  fontWeight: '600',
  fontSize: '0.875rem',
  lineHeight: '160%',
  color: $theme.colors.textDeep,
}))
